import type { ComponentType, LazyExoticComponent } from 'react';
import { lazy } from 'react';

export interface DesktopApp {
  id: string;
  label: string;
  icon: string;
  route?: string;
  component?: LazyExoticComponent<ComponentType<Record<string, unknown>>>;
  width: string;
  height: string;
  authRequired?: boolean;
  hideWhenAuthenticated?: boolean;
  adminOnly?: boolean;
  memberOnly?: boolean;
  normieOnly?: boolean;
  hideFromDesktopIcon?: boolean;
  hideFromStartMenu?: boolean;
}


const BoardPage = lazy(() => import('../pages/BoardPage').then(m => ({ default: m.BoardPage })));
const ChatPage = lazy(() => import('../pages/ChatPage').then(m => ({ default: m.ChatPage })));
// const GptPage = lazy(() => import('../pages/GptPage').then(m => ({ default: m.GptPage })));
const RssPage = lazy(() => import('../pages/RssPage').then(m => ({ default: m.RssPage })));
const ProfilePage = lazy(() => import('../pages/ProfilePage').then(m => ({ default: m.ProfilePage })));
const AdminPage = lazy(() => import('../pages/AdminPage').then(m => ({ default: m.AdminPage })));
const LoginPage = lazy(() => import('../pages/LoginPage').then(m => ({ default: m.LoginPage })));
const RegisterPage = lazy(() => import('../pages/RegisterPage').then(m => ({ default: m.RegisterPage })));
const TermsPage = lazy(() => import('../pages/TermsPage').then(m => ({ default: m.TermsPage })));
const PrivacyPage = lazy(() => import('../pages/PrivacyPage').then(m => ({ default: m.PrivacyPage })));
const AboutPage = lazy(() => import('../pages/AboutPage').then(m => ({ default: m.AboutPage })));
const ShopPage = lazy(() => import('../pages/ShopPage').then(m => ({ default: m.ShopPage })));
// const GlobalMonitorPage = lazy(() => import('../pages/GlobalMonitorPage').then(m => ({ default: m.GlobalMonitorPage })));
const TheoryLibraryPage = lazy(() => import('../pages/TheoryLibraryPage').then(m => ({ default: m.TheoryLibraryPage })));
const SolitairePage = lazy(() => import('../pages/SolitairePage').then(m => ({ default: m.SolitairePage })));
const ErhTerminal = lazy(() => import('../components/desktop/ErhTerminal').then(m => ({ default: m.ErhTerminal })));
export const DESKTOP_APPS: DesktopApp[] = [
  {
    id: 'erhterminal',
    label: 'ERH Terminal',
    icon: '/icons/erh-terminal.svg',
    component: ErhTerminal,
    width: '760px',
    height: '520px',
    authRequired: true,
    hideFromDesktopIcon: true,
  },
  {
    id: 'board',
    label: 'Message Board',
    icon: '📝',
    route: '/board',
    component: BoardPage,
    width: 'min(90vw, 1200px)',
    height: '85vh',
    authRequired: true,
    memberOnly: true,
  },
  {
    id: 'chat',
    label: 'Chat Room',
    icon: '💬',
    route: '/chat',
    component: ChatPage,
    width: 'min(90vw, 1400px)',
    height: '85vh',
    authRequired: true,
    memberOnly: true,
  },
  // {
  //   id: 'gpt',
  //   label: 'ERHgpt',
  //   icon: '⚡',
  //   route: '/gpt',
  //   component: GptPage,
  //   width: 'min(90vw, 860px)',
  //   height: '80vh',
  //   authRequired: true,
  //   memberOnly: true,
  // },
  // {
  //   id: 'worldmonitor',
  //   label: 'Global Monitor',
  //   icon: '/icons/global-monitor.svg',
  //   route: '/monitor',
  //   component: GlobalMonitorPage,
  //   width: 'min(96vw, 1680px)',
  //   height: '88vh',
  //   authRequired: true,
  //   memberOnly: true,
  // },
  {
    id: 'rss',
    label: 'RSS',
    icon: '📡',
    route: '/rss',
    component: RssPage,
    width: 'min(90vw, 1400px)',
    height: '85vh',
    authRequired: true,
    memberOnly: true,
  },
  {
    id: 'shop',
    label: 'Shop',
    icon: '🛍️',
    route: '/shop',
    component: ShopPage,
    width: 'min(90vw, 1200px)',
    height: '85vh',
    authRequired: true,
    memberOnly: true,
  },
  {
    id: 'theorylibrary',
    label: 'Theory Archive',
    icon: '📚',
    route: '/theories',
    component: TheoryLibraryPage,
    width: 'min(96vw, 1500px)',
    height: '88vh',
    authRequired: true,
    memberOnly: true,
  },
  {
    id: 'solitaire',
    label: 'ERH Solitaire',
    icon: '🃏',
    route: '/solitaire',
    component: SolitairePage,
    width: 'min(90vw, 960px)',
    height: '85vh',
    authRequired: true,
    memberOnly: true,
  },
  {
    id: 'profile',
    label: 'Profile',
    icon: '👤',
    route: '/profile',
    component: ProfilePage,
    width: 'min(90vw, 1200px)',
    height: '85vh',
    authRequired: true,
    memberOnly: true,
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: '🔧',
    route: '/admin',
    component: AdminPage,
    width: 'min(95vw, 1600px)',
    height: '90vh',
    authRequired: true,
    adminOnly: true,
    memberOnly: true,
  },
  {
    id: 'register',
    label: 'Register',
    icon: '📝',
    route: '/register',
    component: RegisterPage,
    width: '400px',
    height: '500px',
    hideWhenAuthenticated: true,
    hideFromDesktopIcon: true,
    hideFromStartMenu: true,
  },
  {
    id: 'login',
    label: 'login',
    icon: '/images/logoerhbestwhte.png',
    route: '/login',
    component: LoginPage,
    width: '400px',
    height: '500px',
    hideWhenAuthenticated: true,
    hideFromStartMenu: true,
  },
  {
    id: 'about',
    label: 'About',
    icon: '📄',
    route: '/about',
    component: AboutPage,
    width: '600px',
    height: '500px',
    hideFromDesktopIcon: true,
  },
  {
    id: 'terms',
    label: 'Terms',
    icon: '📋',
    route: '/terms',
    component: TermsPage,
    width: '700px',
    height: '600px',
    hideFromDesktopIcon: true,
  },
  {
    id: 'privacy',
    label: 'Privacy',
    icon: '🔒',
    route: '/privacy',
    component: PrivacyPage,
    width: '700px',
    height: '600px',
    hideFromDesktopIcon: true,
  },
];

export function getAppByRoute(route: string): DesktopApp | undefined {
  return DESKTOP_APPS.find(app => app.route === route);
}

export function getAppById(id: string): DesktopApp | undefined {
  return DESKTOP_APPS.find(app => app.id === id);
}
